// @ts-nocheck
import { Column } from 'react-table'
import { HawalaBranchInfoCell } from './HawalaBranchInfoCell'
import { HawalaBranchActionsCell } from './HawalaBranchActionsCell'
import { HawalaBranchSelectionCell } from './HawalaBranchSelectionCell'
import { HawalaBranchCustomHeader } from './HawalaBranchCustomHeader'
import { HawalaBranchSelectionHeader } from './HawalaBranchSelectionHeader'
import { HawalaBranch } from '../../core/_models'
import { FormattedMessage } from 'react-intl'
import dayjs from 'dayjs'

const hawala_branchesColumns: ReadonlyArray<Column<HawalaBranch>> = [
  {
    Header: (props) => <HawalaBranchSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <HawalaBranchSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <HawalaBranchCustomHeader
        tableProps={props}
        title={<FormattedMessage id='HAWALABRANCH.TABLE.COLUMN.NAME' defaultMessage='نام برنچ' />}
        className='min-w-150px'
      />
    ),
    accessor: 'name',
  },
  {
    Header: (props) => (
      <HawalaBranchCustomHeader
        tableProps={props}
        title={<FormattedMessage id='HAWALABRANCH.TABLE.COLUMN.EMAIL' defaultMessage='ایمیل' />}
        className='min-w-200px'
      />
    ),
    accessor: 'email',
  },
  {
    Header: (props) => (
      <HawalaBranchCustomHeader
        tableProps={props}
        title={<FormattedMessage id='HAWALABRANCH.TABLE.COLUMN.PHONE' defaultMessage='شماره تماس' />}
        className='min-w-130px'
      />
    ),
    accessor: 'phone_number',
  },
  {
    Header: (props) => (
      <HawalaBranchCustomHeader
        tableProps={props}
        title={<FormattedMessage id='HAWALABRANCH.TABLE.COLUMN.TYPE' defaultMessage='نوع کمیسیون' />}
        className='min-w-130px'
      />
    ),
    accessor: 'commission_type',
    Cell: ({ value }) => (
      <span>{value === 'percentage' ? 'درصدی' : 'ثابت'}</span>
    ),
  },
  {
    Header: (props) => (
      <HawalaBranchCustomHeader
        tableProps={props}
        title={<FormattedMessage id='HAWALABRANCH.TABLE.COLUMN.AMOUNT' defaultMessage='مقدار کمیسیون' />}
        className='min-w-130px'
      />
    ),
    accessor: 'amount',
    Cell: ({ value }) => <span>{parseFloat(value).toFixed(2)}</span>,
  },
  {
    Header: (props) => (
      <HawalaBranchCustomHeader
        tableProps={props}
        title={<FormattedMessage id='HAWALABRANCH.TABLE.COLUMN.STATUS' defaultMessage='وضعیت' />}
        className='min-w-100px'
      />
    ),
    accessor: 'status',
    Cell: ({ value }) => {
      const label = value === 'active' ? 'فعال' : 'غیرفعال'
      const className = value === 'active' ? 'badge badge-success' : 'badge badge-danger'
      return <span className={className}>{label}</span>
    },
  },
  {
    Header: (props) => (
      <HawalaBranchCustomHeader
        tableProps={props}
        title={<FormattedMessage id='HAWALABRANCH.TABLE.COLUMN.CREATED_AT' defaultMessage='تاریخ ایجاد' />}
        className='min-w-160px'
      />
    ),
    accessor: 'created_at',
    Cell: ({ value }) => <span>{dayjs(value).format('YYYY-MM-DD HH:mm:ss')}</span>,
  },
  {
    Header: (props) => (
      <HawalaBranchCustomHeader
        tableProps={props}
        title={<FormattedMessage id='TABLE.GENERAL.ACTION' defaultMessage='عملیات' />}
        className='text-end min-w-100px'
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => (
      <HawalaBranchActionsCell id={props.data[props.row.index].id} />
    ),
  },
]

export { hawala_branchesColumns }
